export const PROGRAM_PROSPECTS_1_CONSTANTS = {
  DEFAULT_ROW: {
    id: "1",
    meta_title: "Career Path",
    meta_title_text_color: "#000000",
    meta_description: "Description of the career path",
    meta_description_text_color: "#666666",
    meta_desktop_icon: "",
    meta_desktop_icon_alt: "",
    meta_mobile_icon: "",
    meta_mobile_icon_alt: "",
    meta_desktop_card_color: "#FFFFFF",
    meta_mobile_card_color: "#FFFFFF",
    meta_priority: 1,
    meta_status: true,
  },

  PROGRAM_PROSPECTS_FIELDS_CONFIG: [
    {
      fieldName: "title",
      label: "Program Prospects Title",
      value: "Program Prospects",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Program Prospects Title",
      required: false,
      defaultValue: "Program Prospects",
    },
    {
      fieldName: "title_text_color",
      label: "Title Text Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter title text color (e.g., #000000)",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "sub_title",
      label: "Sub Title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Sub Title",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "sub_title_text_color",
      label: "Sub Title Text Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter sub title text color (e.g., #000000)",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "background_color",
      label: "Background Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter background color (e.g., #FFFFFF)",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "status",
      label: "Program Prospects Status",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable Program Prospects Section",
      required: false,
      defaultValue: false,
    },
  ],

  METADATA_FIELDS: [
    {
      header: "Desktop Icon",
      fieldName: "meta_desktop_icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Desktop Icon",
    },
    {
      header: "Mobile Icon",
      fieldName: "meta_mobile_icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Mobile Icon",
    },
    {
      header: "Icon Alt",
      fieldName: "meta_desktop_icon_alt",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Desktop Icon Alt Text",
    },
    // {
    //   header: "Mobile Icon Alt",
    //   fieldName: "meta_mobile_icon_alt",
    //   value: "",
    //   valueType: "string",
    //   filedType: "INPUT",
    //   placeholder: "Enter Mobile Icon Alt Text",
    // },
    {
      header: "Title",
      fieldName: "meta_title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Title",
      required: true,
    },
    {
      header: "Title desktop Text Color",
      fieldName: "meta_title_text_color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter title text color (e.g., #000000)",
    },
    {
      header: "Title mobile Text Color",
      fieldName: "meta_mobile_title_text_color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter title text color (e.g., #000000)",
    },
    {
      header: "Description",
      fieldName: "meta_description",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Enter Description",
    },
    {
      header: "Description desktop Text Color",
      fieldName: "meta_description_text_color",
      value: "#666666",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter description text color (e.g., #666666)",
    },
    {
      header: "Desktop Card Color",
      fieldName: "meta_desktop_card_color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter desktop card color (e.g., #FFFFFF)",
    },
    {
      header: "Mobile Card Color",
      fieldName: "meta_mobile_card_color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter mobile card color (e.g., #FFFFFF)",
    },
    {
      header: "Priority",
      fieldName: "meta_priority",
      value: 1,
      valueType: "number",
      filedType: "INPUT",
      placeholder: "Enter Priority",
      required: true,
    },
    {
      header: "Status",
      fieldName: "meta_status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable",
    },
  ],
};

